export default {"src":"/_next/static/media/instagram.a19b9e65.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};